<template>
<div>
  <form @submit.prevent="submit">
    <b-row>
     
      <b-col sm="12">

        <b-form-group label="Instructivo de Embarque">
          <v-select
          
            :options="boardinginstructions"
            v-model="$v.data.boardinginstruction.$model"
            :state="$v.data.boardinginstruction.$dirty ? !$v.data.boardinginstruction.$error : null"
            label="text"
            :reduce="text => text.value"
            class="style-chooser ">
          </v-select>

      </b-form-group>

      </b-col>
    </b-row>
  </form>
  </div>
</template>

<script>

  import {required, numeric, minLength, between} from 'vuelidate/lib/validators'
  import { ModelSelect } from "vue-search-select";
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css';


  export default {
    name: "formListaEmbarque",
      components: {
    ModelSelect,
        vSelect
  },
  props: ["data"],
    data() {
      return {
          boardinginstructions:[],
      }
    },
    validations: {

      data:{

boardinginstruction: {required},
      }
        

    },
    mounted () {
      this.loadDataForm();
    },
    methods: {
      saveForm(){
       this.$v.$touch();
      if (this.$v.$invalid) {
        return 0;
      } else {
        return 1;
      }
      },
      loadDataForm(){
        this.$axios.get ('/api/comex/shipment/getShipment/')
          .then(res => {
            let objInfo= res.data;
            for(let i in objInfo)
            {
            this.boardinginstructions.push({value: objInfo[i].id, text: objInfo[i].boarding_number+"-"+objInfo[i].shipment_type.name});
            }
          })
        .catch(error => {
          console.log(error.response)
        });
      },
      submit() {
      },
    },
    beforeMount() {
      
    },
  }

</script>

<style scoped>

</style>
